import { ReactComponent as HomeIcon } from "../../assets/icons/home.svg";

//Channels
import { ReactComponent as InvoiceIcon } from "../../assets/icons/invoice.svg";
import { ReactComponent as TablesIcon } from "../../assets/icons/table7.svg";
import { ReactComponent as POSIcon } from "../../assets/icons/calculator.svg";

//Products
import { ReactComponent as CatalogIcon } from "../../assets/icons/shopping-bag.svg";
import { ReactComponent as InventoryIcon } from "../../assets/icons/storage.svg";

//Management
import { ReactComponent as BranchesIcon } from "../../assets/icons/shop.svg";
import { ReactComponent as DriverIcon } from "../../assets/icons/truck_icon.svg";
import { ReactComponent as BusinessesIcon } from "../../assets/icons/briefcase.svg";
import { ReactComponent as WaitingListIcon } from "../../assets/icons/Waitlisting.svg";
import { ReactComponent as BookingIcon } from "../../assets/icons/timetable.svg";

//Insights
import { ReactComponent as OverviewIcon } from "../../assets/icons/statistics.svg";
import { ReactComponent as SalesIcon } from "../../assets/icons/pie-chart.svg";
import { ReactComponent as CustomersIcon } from "../../assets/icons/user.svg";
import { ReactComponent as DownloadsIcon } from "../../assets/icons/shopping-bag-3.svg";

//Growth
import { ReactComponent as MarketingIcon } from "../../assets/icons/marketing.svg";

//More
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as AddOnsIcon } from "../../assets/icons/add.svg";
import { ReactComponent as QuestionIcon } from "../../assets/icons/Help.svg";
import { ReactComponent as OpenStoreIcon } from "../../assets/icons/Redirect.svg";
import { ReactComponent as RequestFeatureIon } from "../../assets/icons/message-smile-square.svg";

import { icon } from "leaflet";

export const sideNavItems = (props) => {
  const {
    settings,
    permissions,
    userId,
    config,
    bellHasNewOrders,
    bellHasNewBusinessOrders,
    hasPendingPurchaseOrder,
    showCustomerBookingBadge,
    showDownloadsBadge,
    is_staff,
    username,
    feedback_exists,
    profile,
    hasRequestsNotifications,
    history,
    blockingVerification,
  } = props;
  const pinnedItems =
    JSON.parse(localStorage.getItem(`pinnedItems-${userId}`)) || [];

  const IconStyle = {
    height: "16px",
    width: "16px",
    verticalAlign: "middle",
    fill: "#0099cc",
    position: "relative",
    bottom: "3px",
    marginLeft: config.direction == "ltr" ? "0px" : "15px",
    marginRight: config.direction == "rtl" ? "0px" : "15px",
  };
  const navItems = [
    {
      type: "group",
      key: "grpPinned",
      label: "Pinned",
      defaultOpen: true, //Not used
      isVisible: true,
      showBadge: false,
      children: [
        {
          type: "item",
          key: "Home-Menu",
          label: "Home",
          icon: <HomeIcon style={IconStyle} />,
          route: "/manage/home",
          isVisible: true,
          isPinned: true,
        },
      ],
    },

    {
      type: "group",
      key: "grpChannels",
      label: "Channels",
      defaultOpen: false,
      isVisible: true,
      showBadge: bellHasNewOrders || bellHasNewBusinessOrders,
      children: [
        {
          type: "submenu",
          key: "orders-menu-item",
          label: "Orders",
          icon: <InvoiceIcon style={IconStyle} />,
          isVisible:
            !settings.is_menu &&
            (settings.enable_b2c ||
              !!permissions?.all_permitted_branches?.filter(
                (x) => x.enable_pos === true,
              )?.length),
          showBadge: bellHasNewOrders || bellHasNewBusinessOrders,
          children: [
            {
              type: "item",
              key: "OnlineOrders",
              label: "Online",
              route: "/manage/orders/online",
              showBadge: bellHasNewOrders,
              isVisible:
                !settings.is_menu &&
                (settings.enable_b2c ||
                  !!permissions?.all_permitted_branches?.filter(
                    (x) => x.enable_pos === true,
                  )?.length),
            },
            {
              type: "item",
              key: "BusinessOrders",
              label: "BusinessOrders",
              route: "/manage/business_orders",
              isVisible:
                permissions.can_view_business_orders &&
                settings.enable_businesses,
              showBadge: bellHasNewBusinessOrders,
            },
            {
              type: "item",
              key: "Pending",
              label: "Abandoned",
              route: "/manage/pending",
              isVisible:
                settings.enable_b2c && permissions.can_view_pending_orders,
            },
          ],
        },
        {
          type: "item",
          key: "POS-Menu",
          label: "POS",
          icon: <POSIcon style={IconStyle} />,
          route: "/manage/POS",
          isVisible: !settings.is_menu && permissions.can_create_orders,
        },
      ],
    },

    {
      type: "group",
      key: "grpProducts",
      label: "Products",
      defaultOpen: false,
      isVisible: true,
      showBadge: hasPendingPurchaseOrder,
      children: [
        {
          type: "item",
          key: "products-menu-item",
          label: "Catalog",
          icon: <CatalogIcon style={IconStyle} />,
          route: "/manage/products",
          isVisible: true,
        },
        {
          type: "submenu",
          key: "Inventory",
          label: "Inventory",
          icon: <InventoryIcon style={IconStyle} />,
          route: "/manage/products",
          isVisible:
            !settings.is_menu &&
            settings.enable_stocked &&
            settings.enable_advanced_inventory_system,
          showBadge: hasPendingPurchaseOrder,
          children: [
            {
              type: "item",
              key: "Inventoryitems",
              label: "Items",
              route: "/manage/items",
              isVisible: true,
            },
            {
              type: "item",
              key: "units",
              label: "Units",
              route: "/manage/units",
              isVisible: true,
            },
            {
              type: "item",
              key: "suppliers",
              label: "Suppliers",
              route: "/manage/suppliers",
              isVisible: permissions.can_view_purchase_orders,
            },
            {
              type: "item",
              key: "purchaseOrders",
              label: "Purchase",
              route: "/manage/purchase_orders",
              showBadge: hasPendingPurchaseOrder,
              isVisible: permissions.can_view_purchase_orders,
            },
            {
              type: "item",
              key: "transferOrders",
              label: "Stock Transfer",
              route: "/manage/transfer_orders",
              isVisible: permissions.can_view_transfer_orders,
            },
            {
              type: "item",
              key: "ProductionOrders",
              label: "Production",
              route: "/manage/production_orders",
              isVisible: permissions.can_view_production_orders,
            },
            {
              type: "item",
              key: "StockUpdateOrders",
              label: "Stock Update",
              route: "/manage/stock_update_orders",
              isVisible: permissions.can_view_stock_update_orders,
            },
          ],
        },
      ],
    },

    {
      type: "group",
      key: "grpManagement",
      label: "Management",
      defaultOpen: false,
      isVisible: true,
      showBadge: false,
      children: [
        {
          type: "item",
          key: "Branches-Menu",
          label: "Branches",
          icon: <BranchesIcon style={IconStyle} />,
          route: "/manage/locations",
          isVisible: true,
        },
        {
          type: "item",
          key: "drivers",
          label: "Drivers",
          icon: <DriverIcon style={IconStyle} />,
          route: "/manage/drivers",
          isVisible: settings.enable_driver && permissions.can_view_driver,
        },
        {
          type: "item",
          key: "businesses-menu-item",
          label: "Businesses",
          icon: <BusinessesIcon style={IconStyle} />,
          route: "/manage/businesses",
          isVisible: settings.enable_businesses,
        },
        {
          type: "item",
          key: "waitingLists",
          label: "Waiting Lists",
          icon: <WaitingListIcon style={IconStyle} />,
          route: "/manage/waiting-lists",
          isVisible: settings.enable_waiting_lists,
        },
        {
          type: "item",
          key: "tables",
          label: "Dine-In",
          icon: <TablesIcon style={IconStyle} />,
          route: "/manage/tables",
          isVisible: settings.enable_table_qr,
        },
        {
          type: "submenu",
          key: "bookings-menu-item",
          label: "Booking",
          icon: <BookingIcon style={IconStyle} />,
          showBadge: showCustomerBookingBadge,
          isVisible:
            !settings.is_menu &&
            settings.package !== 0 &&
            (settings.enable_booking || settings.enable_resource_based_booking),
          children: [
            {
              type: "item",
              key: "events",
              label: "Events",
              route: "/manage/bookings",
              isVisible: settings.enable_booking,
            },
            {
              type: "item",
              key: "attendance-scanqr",
              label: "Attendance",
              route: "/manage/booking/attendance",
              isVisible:
                settings.enable_booking && settings.enable_attendance_tracking,
            },
            {
              type: "item",
              key: "appointments",
              label: "Appointments",
              route: "/manage/services",
              isVisible: settings.enable_resource_based_booking,
            },
            {
              type: "item",
              key: "providers",
              label: "Providers",
              route: "/manage/ServiceProviders",
              isVisible: settings.enable_resource_based_booking,
            },
          ],
        },
      ],
    },
    {
      type: "group",
      key: "grpInsights",
      label: "Reports",
      defaultOpen: false,
      isVisible: !settings.is_menu,
      showBadge: false,
      children: [
        {
          type: "item",
          key: "reportsOverview",
          label: "Overview",
          route: "/manage/reports/overview",
          isVisible: true,
          icon: <OverviewIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "sales",
          label: "Sales",
          route: "/manage/reports/sales",
          isVisible: true,
          icon: <SalesIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "byProductReport",
          label: "Products",
          route: "/manage/reports/products",
          isVisible: true,
          icon: <CatalogIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "customersReport",
          label: "Customers",
          route: "/manage/reports/customers",
          isVisible: true,
          icon: <CustomersIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "promotionsReport",
          label: "Promotions",
          route: "/manage/reports/promotions",
          isVisible: true,
          icon: <MarketingIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "deliveryReport",
          label: "Delivery",
          route: "/manage/reports/delivery",
          isVisible: true,
          icon: <DriverIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "tablesReport",
          label: "Tables",
          route: "/manage/reports/tables",
          isVisible: settings.enable_table_qr,
          icon: <TablesIcon style={IconStyle} />,
        },
        {
          type: "item",
          key: "Downloads",
          label: "Downloads",
          route: "/manage/reports/downloads",
          isVisible: true,
          icon: <DownloadsIcon style={IconStyle} />,
        },
      ],
    },
    {
      type: "group",
      key: "grpGrowth",
      label: "Growth",
      defaultOpen: false,
      isVisible: true,
      showBadge: false,
      children: [
        {
          type: "submenu",
          key: "customers-menu-item",
          label: "Customers",
          icon: <CustomersIcon style={IconStyle} />,
          isVisible:
            permissions.can_view_customers &&
            (settings.enable_feedback || settings.enable_survey),
          children: [
            {
              type: "item",
              key: "customersList",
              label: "Customers List",
              route: "/manage/customers",
              isVisible: !settings.is_menu,
            },
            {
              type: "item",
              key: "usersList",
              label: "Users List",
              route: "/manage/users",
              isVisible: settings.enable_social_auth_staff,
            },
            {
              type: "item",
              key: "topups",
              label: "Top-ups",
              route: "/manage/Topups",
              isVisible: settings.enable_wallet_staff,
            },
            {
              type: "item",
              key: "Feedbacks",
              label: "Feedback",
              route: "/manage/feedback",
              showBadge: feedback_exists,
              isVisible:
                settings.enable_feedback && permissions.can_view_feedbacks,
            },
            {
              type: "item",
              key: "survey-list",
              label: "Survey",
              route: "/manage/surveys",
              isVisible: settings.enable_survey,
            },
          ],
        },
        {
          type: "submenu",
          key: "Marketing-Menu",
          label: "Marketing",
          icon: <MarketingIcon style={IconStyle} />,

          isVisible:
            ((settings.enable_promotions || settings.enable_coupons) &&
              permissions.can_view_promotions &&
              !settings.is_menu) ||
            permissions.can_view_social_section,

          children: [
            {
              type: "item",
              key: "Coupons",
              label: "Coupons",
              route: "/manage/coupons",
              isVisible: settings.enable_coupons,
            },
            {
              type: "item",
              key: "Promotions",
              label: "Promotions",
              route: "/manage/promotions",
              isVisible: settings.enable_promotions,
            },
            {
              type: "item",
              key: "Popup Banner",
              label: "Popup Banner",
              route: "/manage/appearance/PopupBanner",
              isVisible: settings.enable_popup_banner_staff,
            },
            {
              type: "item",
              key: "Social",
              label: "Social",
              route: "/manage/Integration/Marketing",
              isVisible: settings.can_view_social_section,
            },
            {
              type: "item",
              key: "Raffle",
              label: "Raffle",
              route: "/manage/raffle",
              isVisible:
                settings.enable_promotions &&
                permissions.can_view_customers &&
                permissions.can_create_promotions,
            },
            {
              type: "item",
              key: "Abandoned Carts",
              label: "Abandoned Carts",
              route: "/manage/abandoned",
              isVisible: settings.enable_abandoned_carts,
            },
            {
              type: "item",
              key: "Campaigns",
              label: "Campaigns",
              route: "/manage/campaign",
              isVisible: settings.enable_sms_campaigns,
            },
            {
              type: "item",
              key: "App Notifications",
              label: "App Notifications",
              route: "/manage/MobileNotifications",
              isVisible: settings.has_mobile_app,
            },
            {
              type: "item",
              key: "OptimizeApp",
              label: "OptimizeApp",
              route: "/manage/optimize",
              isVisible: settings.enable_optimize,
            },
          ],
        },
      ],
    },

    {
      type: "group",
      key: "grpMore",
      label: "More",
      defaultOpen: false,
      isVisible: true,
      showBadge: false,
      children: [
        {
          type: "item",
          key: "settings-menu-item",
          label: "Settings",
          icon: <SettingsIcon style={IconStyle} />,
          route: "/manage/settings",
          isVisible: true,
        },
        {
          type: "item",
          key: "addons-menu-item",
          label: "Add-Ons",
          icon: <AddOnsIcon style={IconStyle} />,
          route: "/manage/addons",
          isVisible:
            (!settings.created_by_reseller ||
              settings.linked_to_store === "foodics.ordable.com") &&
            settings.base_country !== "Jordan",
        },
        {
          type: "item",
          key: "lua-menu-item",
          label: "Lua",
          icon: (
            <img
              style={{ ...IconStyle, bottom: 0 }}
              src="https://framerusercontent.com/images/erBfC4XSArdnB9ODBzPGO22xo.svg?width=60&height=60"
            />
          ),
          route: "/manage/lua",
          isVisible: settings.enable_lua,
        },
        {
          type: "item",
          key: "openStore",
          label: "Open store",
          icon: <OpenStoreIcon style={IconStyle} />,
          route: "/s",
          isVisible: !settings.is_pos,
          onClick: () => window.open(`https://${settings.domain}/`, "_blank"),
        },
        {
          type: "item",
          key: "faqs",
          label: "Q&A",
          icon: <QuestionIcon style={IconStyle} />,

          route: "/manage/faqs",
          isVisible:
            !settings.linked_to_store ||
            settings.linked_to_store === "foodics.ordable.com",
        },
        {
          type: "item",
          key: "requestFeature",
          label: "Submit a request",
          icon: (
            <RequestFeatureIon
              style={{
                ...IconStyle,
                bottom: 0,
                fill: "#00a200",
                width: 20,
                height: 20,
                [`margin${config.direction === "rtl" ? "Left" : "Right"}`]: 12,
                position: "relative",
                [config.direction === "rtl" ? "right" : "left"]: -2,
              }}
            />
          ),

          route: "/manage/help",
          routeState: {
            lastPath: history?.location?.pathname,
          },
          isVisible:
            (is_staff &&
              !blockingVerification &&
              (is_staff ||
                (!!profile &&
                  profile.profile?.did_verify_phone &&
                  profile.profile?.did_verify_email))) ||
            settings.can_submit_request,
        },

        {
          type: "item",
          key: "staff",
          label: "Staff",
          route: "/manage/staff",
          isVisible: is_staff,
        },

        {
          type: "submenu",
          key: "Import",
          label: "Import",
          isVisible: is_staff,

          children: [
            {
              type: "item",
              key: "import-zyda",
              label: "Zyda Customers",
              route: "/manage/import/customers/zyda",
              isVisible:
                username.includes("salem") ||
                username.includes("Naser") ||
                username.includes("khara") ||
                username.includes("mona"),
            },
            {
              type: "item",
              key: "import-products",
              label: "Products",
              route: "/manage/import/products/template",
              isVisible: true,
            },
            {
              type: "item",
              key: "import-customers-t",
              label: "Customers",
              route: "/manage/import/customers/template",
              isVisible: true,
            },
            {
              type: "item",
              key: "import-product-components",
              label: "Product recipes",
              route: "/manage/import/product-components",
              isVisible: true,
            },
            {
              type: "item",
              key: "import-customers",
              label: "Delivery areas",
              route: "/manage/import/areas/template",
              isVisible: true,
            },
          ],
        },
      ],
    },
  ];
  pinnedItems.forEach((pinnedItem) => {
    let icon = null;
    let searchableList = navItems;
    if (pinnedItem.group) {
      searchableList = searchableList.find((nv) => nv.key === pinnedItem.group);
      icon = searchableList?.icon;
    }
    if (pinnedItem.submenu) {
      searchableList = searchableList?.children.find(
        (nv) => nv.key === pinnedItem.submenu,
      );
      icon = searchableList?.icon || icon;
    }
    if (pinnedItem.key) {
      searchableList = searchableList?.children.find(
        (nv) => nv.key === pinnedItem.key,
      );
      icon = searchableList?.icon || icon;
    }
    if (searchableList) {
      searchableList.isPinned = true;
      navItems[0].children.push({ ...searchableList, icon });
      navItems[0].showBadge = navItems[0].showBadge || searchableList.showBadge;
    }
  });

  if (permissions.can_only_view_own_orders) {
    return navItems.filter((nI) =>
      ["grpPinned", "grpChannels"].includes(nI.key),
    );
  }
  return navItems;
};
